/** Populate calculator tone <select> elements from SunFrogTones. */
(function () {
  const tones = window.SunFrogTones;
  if (!tones?.length) return;

  document.querySelectorAll("select[data-calculator-tone]").forEach((select) => {
    tones.forEach((tone) => {
      const option = document.createElement("option");
      option.value = tone.id;
      option.textContent = tone.label;
      select.appendChild(option);
    });
  });
})();
